import React from "react";
import { useLocation } from "react-router-dom";

const PaymentSuccessScreen = ({ onOk }) => {
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const type = params.get("type");
  return (
    <div className="relative min-h-screen pricing-bg flex items-center justify-center px-4 py-12">
      {/* Background Circles */}
      <div className="absolute top-0 right-0 w-72 h-72 bg-white/30 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-white/30 rounded-full blur-3xl animate-pulse"></div>

      {/* Card */}
      <div className="relative z-10 bg-white/20 backdrop-blur-xl rounded-3xl p-10 max-w-md w-full border border-white/30 shadow-2xl text-center">
        {/* Success Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-white/30 flex items-center justify-center border border-white/40">
            <svg
              className="w-12 h-12 text-green-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
        </div>

        {/* Header */}
        <h1 className="text-3xl font-bold text-white mb-3">
          Payment Successful
        </h1>
        <p className="text-white/80 text-md mb-8">
          Thank you for your purchase! Your payment has been processed
          successfully. You can now continue exploring our services.
        </p>

        {/* OK Button */}
        <button
          onClick={() =>
            (window.location.href = `https://mpubx.app.link/${type}`)
          }
          className="w-full py-3 rounded-xl font-semibold text-lg transition-all duration-300
                 bg-white text-purple-700 hover:bg-white/90 shadow-lg hover:shadow-xl hover:scale-105"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccessScreen;
